import { NomLanguages } from '../constants';

import { Injectable } from '@angular/core';
import { PropertyViewConfig } from './feed-settings.service';
import { TranslateService } from '@ngx-translate/core';
import { User } from '../models/core.models';

@Injectable({
  providedIn: 'root',
})
export class WidgetSettingsService {
  private widgetConfiguration;
  private configLoaded = false;

  constructor(private translate: TranslateService) {}

  async initializeConfigurations(): Promise<void> {
    const keys = [
      'widget.language-settings.default',
      'widget.language-settings.english',
      'widget.language-settings.arabic',
    ];

    const translations = await this.translate.get(keys).toPromise();

    const widgetProperties: PropertyViewConfig[] = [
      {
        label: translations['widget.language-settings.default'],
        path: NomLanguages.DEFAULT,
        propertyUri: 'widget_language_default',
        icon: ['fas', 'language'],
        selected: true,
        visibility: ['view-properties'],
        isRadio: true,
        radioGroup: 'language',
      },
      {
        label: translations['widget.language-settings.english'],
        path: NomLanguages.ENGLISH,
        propertyUri: 'widget_language_english',
        icon: ['fas', 'language'],
        selected: false,
        visibility: ['view-properties'],
        isRadio: true,
        radioGroup: 'language',
      },
      {
        label: translations['widget.language-settings.arabic'],
        path: NomLanguages.ARABIC,
        propertyUri: 'widget_language_arabic',
        icon: ['fas', 'language'],
        selected: false,
        visibility: ['view-properties'],
        isRadio: true,
        radioGroup: 'language',
      },
    ];

    this.widgetConfiguration = [...widgetProperties];
    this.configLoaded = true;
  }

  getWidgetLanguageConfig(user: User): Promise<PropertyViewConfig[]> {
    return new Promise(async (resolve) => {
      if (!this.configLoaded) {
        await this.initializeConfigurations();
      }
      let widgetConfig = this.widgetConfiguration;
      if (widgetConfig) {
        widgetConfig = widgetConfig.filter((config) => {
          return (
            !config.permission || user?.feature_components[config.permission]
          );
        });
      }
      resolve(widgetConfig);
    });
  }
}
